// dependencies
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { changePageUI as updateUI } from "Actions/ui";

// selectors
import { getUI } from "Selectors/ui";
import { getRecentUsersLimit, getSkipCount } from "./selectors";

/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	// set the initial UI
	const initialUI = ui;
	dispatch(updateUI([], initialUI));
};
